import React, { useEffect, useState } from 'react';
import NodeContainer from '../node-container/NodeContainer';
import { Handle, Position, useNodes } from '@xyflow/react';
import styles from './ApiNode.module.scss';
import ApiModal from './api-modal/ApiModal';

const ApiNode = ({ id, selected, onNodesDelete }) => {
  const nodes = useNodes();
  const node = nodes.find((node) => node.id === id);

  const [isError, setIsError] = useState(node?.is_Error || false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (node?.api) {
      if (!node?.api?.requestUrl || !node?.api?.method) {
        setIsError(true);
      } else {
        setIsError(false);
      }
    } else {
      setIsError(node?.is_Error || true);
    }
  }, [node?.api]);

  return (
    <>
      <NodeContainer
        name={node.title || 'API'}
        id={id}
        onClick={() => setIsModalOpen(true)}
        backgroundColor={node?.color}
        selected={selected}
        onNodesDelete={onNodesDelete}
        node={node}
        isError={isError}
      >
        <Handle
          className='custom-handle'
          type='target'
          position={Position.Left}
        />
        <div className={styles['node-container']}>
          {node?.api?.method && (
            <>
              <div className={styles['number-container']}>
                <p>{String(node?.api?.method || '').toUpperCase()}</p>
              </div>
              <hr className={styles['separator']} />
              {!node?.api?.requestUrl ? (
                <p className={styles.placeholder}>Enter request URL</p>
              ) : (
                <p className={styles['message-preview']}>
                  {node?.api?.requestUrl}
                </p>
              )}
            </>
          )}
        </div>

        <Handle
          type='source'
          className='custom-handle'
          position={Position.Right}
        />
      </NodeContainer>

      <ApiModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title='API'
        id={id}
        isError={isError}
      />
    </>
  );
};

export default ApiNode;
